import axios from "axios";
import { logOut } from "../../common/utils";
import jwt_decode from "jwt-decode";

export default class EsportaSpacchettatoService{
    getSpacchettatoSanzioni(dataInizio,dataFine,onSuccess,onError){
        let host = process.env.REACT_APP_API_URL;
        var objUser = JSON.parse(sessionStorage.getItem("user"));
        var decoded = jwt_decode(objUser.token);
        const configHeaders = {
          headers: {
            Authorization: "Bearer " + objUser.token,
            CF: decoded.CFA,
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers":
              "Origin, X-Requested-With, Content-Type, Accept",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          },
        };

        const dataOreInizio =  new Date().setDate(new Date().getDate() - 30);
        const dataOraCorrettaInizio  = new Date(dataOreInizio).setHours(0, 0, 0);

        dataInizio === ""
        ? (dataInizio = dataOraCorrettaInizio)
        : (dataInizio = +new Date(dataInizio).setHours(0, 0, 0));
        dataFine === ""
        ? (dataFine = +new Date().setHours(23,59, 59))
        : (dataFine = +new Date(dataFine).setHours(23,59, 59));

        axios
            .get(host+`/api/v1/sanzione/esporta/pagati/${dataInizio}/${dataFine}`,configHeaders)
            .then(
              function  (result){
                    if(result.status === 200){
                        onSuccess(result.data)
                    }else if(result.status === 401){
                        logOut();
                    }else{
                        onError();
                    }
                },
                function (error){
                  onError();
                }
            )

    }

    getSpacchettatoIngiunzioni(dataInizio,dataFine,onSuccess,onError){
      let host = process.env.REACT_APP_API_URL;
      var objUser = JSON.parse(sessionStorage.getItem("user"));
      var decoded = jwt_decode(objUser.token);
      const configHeaders = {
        headers: {
          Authorization: "Bearer " + objUser.token,
          CF: decoded.CFA,
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Headers":
            "Origin, X-Requested-With, Content-Type, Accept",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        },
      };

      const dataOreInizio =  new Date().setDate(new Date().getDate() - 30);
      const dataOraCorrettaInizio  = new Date(dataOreInizio).setHours(0, 0, 0);

      dataInizio === ""
      ? (dataInizio = dataOraCorrettaInizio)
      : (dataInizio = +new Date(dataInizio).setHours(0, 0, 0));
      dataFine === ""
      ? (dataFine = +new Date().setHours(23,59, 59))
      : (dataFine = +new Date(dataFine).setHours(23,59, 59));

      axios
          .get(host+`/api/v1/ingiunzioni/esporta/pagati/${dataInizio}/${dataFine}`,configHeaders)
          .then(
            function  (result){
                  if(result.status === 200){
                      onSuccess(result.data)
                  }else if(result.status === 401){
                      logOut();
                  }else{
                      onError();
                  }
              },
              function (error){
                onError();
              }
          )

  }
}